import React from 'react';

export const BreakdownDescriptionColumn = ({ children, fontSize }) => {
  return <td style={{ fontSize: fontSize, paddingLeft: '30px', paddingBottom: '5px', flexGrow: 1 }}>{children}</td>;
};
